const isTouchDevice = () => 'ontouchend' in document.documentElement;

export default isTouchDevice;
